{
  "address": "h6xvdujoHa6FNB42JeC3pktXyssShCUX5BKzeJGCKix",
  "metadata": {
    "name": "coordinator_pool",
    "version": "0.9.1",
    "spec": "0.1.0",
    "description": "Created with Anchor"
  },
  "instructions": [
    {
      "name": "add_coordinator",
      "discriminator": [
        99,
        176,
        86,
        130,
        54,
        165,
        66,
        69
      ],
      "accounts": [
        {
          "name": "staking_admin_authority",
          "signer": true
        },
        {
          "name": "config_account",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                209,
                29,
                131,
                221,
                214,
                12,
                244,
                206,
                203,
                149,
                189,
                52,
                135,
                150,
                129,
                27,
                6,
                102,
                50,
                107,
                252,
                17,
                109,
                10,
                8,
                90,
                212,
                175,
                48,
                95,
                187,
                255
              ]
            }
          }
        },
        {
          "name": "pool_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114,
                  95,
                  112,
                  111,
                  111,
                  108,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "coordinator_pool_data",
          "writable": true,
          "relations": [
            "pool_config"
          ]
        }
      ],
      "args": [
        {
          "name": "coordinator",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "advance_epoch",
      "discriminator": [
        93,
        138,
        234,
        218,
        241,
        230,
        132,
        38
      ],
      "accounts": [
        {
          "name": "signer",
          "signer": true
        },
        {
          "name": "coordinator_pool_data",
          "writable": true,
          "relations": [
            "coordinator_pool_config"
          ]
        },
        {
          "name": "coordinator_pool_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114,
                  95,
                  112,
                  111,
                  111,
                  108,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "seasons",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  101,
                  97,
                  115,
                  111,
                  110,
                  115
                ]
              }
            ]
          }
        },
        {
          "name": "coordinator_pool_reward_custody",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "coordinator_pool_config"
              },
              {
                "kind": "const",
                "value": [
                  6,
                  221,
                  246,
                  225,
                  215,
                  101,
                  161,
                  147,
                  217,
                  203,
                  225,
                  70,
                  206,
                  235,
                  121,
                  172,
                  28,
                  180,
                  133,
                  237,
                  95,
                  91,
                  55,
                  145,
                  58,
                  140,
                  245,
                  133,
                  126,
                  255,
                  0,
                  169
                ]
              },
              {
                "kind": "account",
                "path": "coordinator_pool_config.crnch_mint",
                "account": "CoordinatorPoolConfig"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140,
                151,
                37,
                143,
                78,
                36,
                137,
                241,
                187,
                61,
                16,
                41,
                20,
                142,
                13,
                131,
                11,
                90,
                19,
                153,
                218,
                255,
                16,
                132,
                4,
                142,
                123,
                216,
                219,
                233,
                248,
                89
              ]
            }
          }
        }
      ],
      "args": []
    },
    {
      "name": "claim",
      "discriminator": [
        62,
        198,
        214,
        193,
        213,
        159,
        108,
        210
      ],
      "accounts": [
        {
          "name": "user_key",
          "writable": true,
          "signer": true,
          "relations": [
            "stake_account"
          ]
        },
        {
          "name": "stake_account_positions"
        },
        {
          "name": "coordinator_pool_data",
          "writable": true,
          "relations": [
            "pool_config"
          ]
        },
        {
          "name": "pool_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114,
                  95,
                  112,
                  111,
                  111,
                  108,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "pool_reward_custody",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "pool_config"
              },
              {
                "kind": "const",
                "value": [
                  6,
                  221,
                  246,
                  225,
                  215,
                  101,
                  161,
                  147,
                  217,
                  203,
                  225,
                  70,
                  206,
                  235,
                  121,
                  172,
                  28,
                  180,
                  133,
                  237,
                  95,
                  91,
                  55,
                  145,
                  58,
                  140,
                  245,
                  133,
                  126,
                  255,
                  0,
                  169
                ]
              },
              {
                "kind": "account",
                "path": "pool_config.crnch_mint",
                "account": "CoordinatorPoolConfig"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140,
                151,
                37,
                143,
                78,
                36,
                137,
                241,
                187,
                61,
                16,
                41,
                20,
                142,
                13,
                131,
                11,
                90,
                19,
                153,
                218,
                255,
                16,
                132,
                4,
                142,
                123,
                216,
                219,
                233,
                248,
                89
              ]
            }
          }
        },
        {
          "name": "stake_account_custody",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "user_key"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                209,
                29,
                131,
                221,
                214,
                12,
                244,
                206,
                203,
                149,
                189,
                52,
                135,
                150,
                129,
                27,
                6,
                102,
                50,
                107,
                252,
                17,
                109,
                10,
                8,
                90,
                212,
                175,
                48,
                95,
                187,
                255
              ]
            }
          }
        },
        {
          "name": "coordinator",
          "docs": [
            "CHECK : The coordinator will be checked against data in the coordinator_pool_data"
          ]
        },
        {
          "name": "stake_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  97,
                  99,
                  99,
                  111,
                  117,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "user_key"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                209,
                29,
                131,
                221,
                214,
                12,
                244,
                206,
                203,
                149,
                189,
                52,
                135,
                150,
                129,
                27,
                6,
                102,
                50,
                107,
                252,
                17,
                109,
                10,
                8,
                90,
                212,
                175,
                48,
                95,
                187,
                255
              ]
            }
          }
        },
        {
          "name": "delegation_record",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  100,
                  101,
                  108,
                  101,
                  103,
                  97,
                  116,
                  105,
                  111,
                  110,
                  95,
                  114,
                  101,
                  99,
                  111,
                  114,
                  100
                ]
              },
              {
                "kind": "account",
                "path": "coordinator"
              },
              {
                "kind": "account",
                "path": "stake_account"
              }
            ]
          }
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [],
      "returns": "u64"
    },
    {
      "name": "create_season",
      "discriminator": [
        38,
        108,
        29,
        127,
        60,
        126,
        101,
        3
      ],
      "accounts": [
        {
          "name": "signer",
          "signer": true
        },
        {
          "name": "pool_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114,
                  95,
                  112,
                  111,
                  111,
                  108,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "seasons",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  101,
                  97,
                  115,
                  111,
                  110,
                  115
                ]
              }
            ]
          }
        }
      ],
      "args": [
        {
          "name": "start_epoch",
          "type": "u64"
        },
        {
          "name": "end_epoch",
          "type": "u64"
        },
        {
          "name": "epoch_emission",
          "type": "u64"
        }
      ]
    },
    {
      "name": "delegate",
      "discriminator": [
        90,
        147,
        75,
        178,
        85,
        88,
        4,
        137
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator_pool_data",
          "writable": true,
          "relations": [
            "pool_config"
          ]
        },
        {
          "name": "pool_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114,
                  95,
                  112,
                  111,
                  111,
                  108,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "coordinator",
          "docs": [
            "CHECK : The coordinator will be checked against data in the pool_data"
          ]
        },
        {
          "name": "config_account",
          "docs": [
            "CHECK : This AccountInfo is safe because it's a checked PDA"
          ],
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ],
            "program": {
              "kind": "account",
              "path": "staking_program"
            }
          }
        },
        {
          "name": "stake_account",
          "docs": [
            "CHECK : This AccountInfo is safe because it's a checked PDA"
          ],
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  97,
                  99,
                  99,
                  111,
                  117,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ],
            "program": {
              "kind": "account",
              "path": "staking_program"
            }
          }
        },
        {
          "name": "stake_account_positions",
          "docs": [
            "CHECK : This AccountInfo is safe because it will checked in staking program"
          ],
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  112,
                  111,
                  115,
                  105,
                  116,
                  105,
                  111,
                  110,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "stake_account"
              }
            ],
            "program": {
              "kind": "account",
              "path": "staking_program"
            }
          }
        },
        {
          "name": "stake_account_custody",
          "docs": [
            "CHECK : This AccountInfo is safe because it will checked in staking program"
          ],
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ],
            "program": {
              "kind": "account",
              "path": "staking_program"
            }
          }
        },
        {
          "name": "staking_program",
          "address": "F5JK739h8ADzhG5xGwezYcYVq4enYM1LPuCkbwQg13G2"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "initialise_seasons",
      "discriminator": [
        17,
        156,
        201,
        93,
        55,
        97,
        107,
        111
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "pool_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114,
                  95,
                  112,
                  111,
                  111,
                  108,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "seasons",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  101,
                  97,
                  115,
                  111,
                  110,
                  115
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "initialize_pool",
      "discriminator": [
        95,
        180,
        10,
        172,
        84,
        174,
        232,
        40
      ],
      "accounts": [
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config_account",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                209,
                29,
                131,
                221,
                214,
                12,
                244,
                206,
                203,
                149,
                189,
                52,
                135,
                150,
                129,
                27,
                6,
                102,
                50,
                107,
                252,
                17,
                109,
                10,
                8,
                90,
                212,
                175,
                48,
                95,
                187,
                255
              ]
            }
          }
        },
        {
          "name": "coordinator_pool_data",
          "writable": true
        },
        {
          "name": "pool_config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114,
                  95,
                  112,
                  111,
                  111,
                  108,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "reward_program_authority",
          "type": "pubkey"
        },
        {
          "name": "y",
          "type": "u64"
        }
      ]
    },
    {
      "name": "lock_season",
      "discriminator": [
        55,
        157,
        55,
        131,
        130,
        140,
        215,
        79
      ],
      "accounts": [
        {
          "name": "signer",
          "signer": true
        },
        {
          "name": "pool_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114,
                  95,
                  112,
                  111,
                  111,
                  108,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "coordinator_pool_data",
          "relations": [
            "pool_config"
          ]
        },
        {
          "name": "seasons",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  101,
                  97,
                  115,
                  111,
                  110,
                  115
                ]
              }
            ]
          }
        }
      ],
      "args": [
        {
          "name": "season_index",
          "type": "u64"
        },
        {
          "name": "coordinators",
          "type": {
            "vec": "u64"
          }
        }
      ]
    },
    {
      "name": "undelegate",
      "discriminator": [
        131,
        148,
        180,
        198,
        91,
        104,
        42,
        238
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator_pool_data",
          "writable": true,
          "relations": [
            "pool_config"
          ]
        },
        {
          "name": "pool_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114,
                  95,
                  112,
                  111,
                  111,
                  108,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "coordinator",
          "docs": [
            "CHECK : The publisher will be checked against data in the pool_data"
          ]
        },
        {
          "name": "config_account",
          "docs": [
            "CHECK : This AccountInfo is safe because it's a checked PDA"
          ],
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ],
            "program": {
              "kind": "account",
              "path": "staking_program"
            }
          }
        },
        {
          "name": "stake_account_positions",
          "docs": [
            "CHECK : This AccountInfo is safe because it's a checked PDA"
          ],
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  112,
                  111,
                  115,
                  105,
                  116,
                  105,
                  111,
                  110,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "stake_account"
              }
            ],
            "program": {
              "kind": "account",
              "path": "staking_program"
            }
          }
        },
        {
          "name": "stake_account",
          "docs": [
            "CHECK : This AccountInfo is safe because it's a checked PDA"
          ],
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  97,
                  99,
                  99,
                  111,
                  117,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ],
            "program": {
              "kind": "account",
              "path": "staking_program"
            }
          }
        },
        {
          "name": "stake_account_custody",
          "docs": [
            "CHECK : This AccountInfo is safe because it's a checked PDA"
          ],
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ],
            "program": {
              "kind": "account",
              "path": "staking_program"
            }
          }
        },
        {
          "name": "staking_program",
          "address": "F5JK739h8ADzhG5xGwezYcYVq4enYM1LPuCkbwQg13G2"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "position_index",
          "type": "u8"
        },
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    }
  ],
  "accounts": [
    {
      "name": "CoordinatorPoolConfig",
      "discriminator": [
        124,
        199,
        111,
        60,
        32,
        22,
        155,
        244
      ]
    },
    {
      "name": "CoordinatorPoolData",
      "discriminator": [
        25,
        156,
        116,
        240,
        144,
        159,
        241,
        182
      ]
    },
    {
      "name": "DelegationRecord",
      "discriminator": [
        203,
        185,
        161,
        226,
        129,
        251,
        132,
        155
      ]
    },
    {
      "name": "Seasons",
      "discriminator": [
        146,
        66,
        244,
        105,
        235,
        8,
        9,
        156
      ]
    },
    {
      "name": "StakingAccount",
      "discriminator": [
        52,
        178,
        251,
        157,
        180,
        186,
        98,
        234
      ]
    },
    {
      "name": "StakingConfig",
      "discriminator": [
        45,
        134,
        252,
        82,
        37,
        57,
        84,
        25
      ]
    },
    {
      "name": "StakingPositions",
      "discriminator": [
        131,
        122,
        43,
        21,
        211,
        48,
        120,
        64
      ]
    }
  ],
  "errors": [
    {
      "code": 6000,
      "name": "CoordinatorNotFound"
    },
    {
      "code": 6001,
      "name": "CoordinatorOrRewardAuthorityNeedsToSign"
    },
    {
      "code": 6002,
      "name": "StakeAccountOwnerNeedsToSign"
    },
    {
      "code": 6003,
      "name": "OutdatedCoordinatorAccounting"
    },
    {
      "code": 6004,
      "name": "TooManyCoordinator"
    },
    {
      "code": 6005,
      "name": "UnexpectedPositionState"
    },
    {
      "code": 6006,
      "name": "PoolDataAlreadyUpToDate"
    },
    {
      "code": 6007,
      "name": "OutdatedCoordinatorCaps"
    },
    {
      "code": 6008,
      "name": "OutdatedDelegatorAccounting"
    },
    {
      "code": 6009,
      "name": "CurrentStakeAccountShouldBeUndelegated"
    },
    {
      "code": 6010,
      "name": "NewStakeAccountShouldBeUndelegated"
    },
    {
      "code": 6011,
      "name": "CoordinatorStakeAccountMismatch"
    },
    {
      "code": 6012,
      "name": "ThisCodeShouldBeUnreachable"
    },
    {
      "code": 6013,
      "name": "InsufficientRewards"
    },
    {
      "code": 6014,
      "name": "InvalidStartEpoch",
      "msg": "Start epoch of the reward program is before the current epoch"
    },
    {
      "code": 6015,
      "name": "UnverifiedCoordinatorCaps"
    },
    {
      "code": 6016,
      "name": "InvalidSlashEventIndex",
      "msg": "Slash event indexes must be sequential and start at 0"
    },
    {
      "code": 6017,
      "name": "InvalidRewardProgramAuthority"
    },
    {
      "code": 6018,
      "name": "InvalidPoolDataAccount"
    },
    {
      "code": 6019,
      "name": "WrongSlashEventOrder",
      "msg": "Slashes must be executed in order of slash event index"
    },
    {
      "code": 6020,
      "name": "CoordinatorCustodyAccountRequired",
      "msg": "Coordinator custody account required"
    },
    {
      "code": 6021,
      "name": "InvalidDelegationFee",
      "msg": "Delegation fee must not be greater than 100%"
    },
    {
      "code": 6022,
      "name": "InvalidCoordinator"
    },
    {
      "code": 6023,
      "name": "InvalidY",
      "msg": "Y should not be greater than 1%"
    },
    {
      "code": 6024,
      "name": "TooMuchExposureToCoordinatorPool",
      "msg": "Too much exposure to coordinator pool"
    },
    {
      "code": 6025,
      "name": "InvalidSlashCustodyAccount"
    },
    {
      "code": 6026,
      "name": "StakingAdminAuthorityRequired",
      "msg": "Only staking admin authority can perform this action"
    },
    {
      "code": 6027,
      "name": "CoordinatorAlreadyExists"
    },
    {
      "code": 6028,
      "name": "InvalidEpochRange",
      "msg": "Invalid epoch range: end epoch must be greater than start epoch"
    },
    {
      "code": 6029,
      "name": "TooManySeasons",
      "msg": "Maximum number of seasons (12) reached"
    },
    {
      "code": 6030,
      "name": "SeasonOverlap",
      "msg": "Season overlaps with an existing season"
    },
    {
      "code": 6031,
      "name": "InvalidSeasonIndex",
      "msg": "Invalid season index"
    },
    {
      "code": 6032,
      "name": "SeasonAlreadyLocked",
      "msg": "Season is already locked with coordinators"
    },
    {
      "code": 6033,
      "name": "NoCoordinatorsToLock",
      "msg": "No coordinators available to lock for the season"
    },
    {
      "code": 6034,
      "name": "TooManyCoordinatorsForSeason",
      "msg": "Too many coordinators for season (max 20)"
    },
    {
      "code": 6035,
      "name": "NoActiveSeason",
      "msg": "No active season"
    }
  ],
  "types": [
    {
      "name": "CoordinatorEventData",
      "repr": {
        "kind": "c"
      },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "self_reward_ratio",
            "type": "u64"
          },
          {
            "name": "other_reward_ratio",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "CoordinatorPoolConfig",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "coordinator_pool_data",
            "type": "pubkey"
          },
          {
            "name": "reward_program_authority",
            "type": "pubkey"
          },
          {
            "name": "crnch_mint",
            "type": "pubkey"
          },
          {
            "name": "y",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "CoordinatorPoolData",
      "serialization": "bytemuck",
      "repr": {
        "kind": "c"
      },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "last_updated_epoch",
            "type": "u64"
          },
          {
            "name": "claimable_rewards",
            "type": "u64"
          },
          {
            "name": "coordinators",
            "type": {
              "array": [
                "pubkey",
                215
              ]
            }
          },
          {
            "name": "del_state",
            "type": {
              "array": [
                {
                  "defined": {
                    "name": "DelegationState"
                  }
                },
                215
              ]
            }
          },
          {
            "name": "self_del_state",
            "type": {
              "array": [
                {
                  "defined": {
                    "name": "DelegationState"
                  }
                },
                215
              ]
            }
          },
          {
            "name": "events",
            "type": {
              "array": [
                {
                  "defined": {
                    "name": "Event"
                  }
                },
                52
              ]
            }
          },
          {
            "name": "num_events",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "DelegationRecord",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "last_epoch",
            "type": "u64"
          },
          {
            "name": "next_slash_event_index",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "DelegationState",
      "repr": {
        "kind": "c"
      },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "total_delegation",
            "type": "u64"
          },
          {
            "name": "delta_delegation",
            "type": "i64"
          }
        ]
      }
    },
    {
      "name": "Event",
      "repr": {
        "kind": "c"
      },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "epoch",
            "type": "u64"
          },
          {
            "name": "y",
            "type": "u64"
          },
          {
            "name": "extra_space",
            "type": {
              "array": [
                "u64",
                7
              ]
            }
          },
          {
            "name": "event_data",
            "type": {
              "array": [
                {
                  "defined": {
                    "name": "CoordinatorEventData"
                  }
                },
                215
              ]
            }
          }
        ]
      }
    },
    {
      "name": "Season",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "start_epoch",
            "type": "u64"
          },
          {
            "name": "end_epoch",
            "type": "u64"
          },
          {
            "name": "epoch_emission",
            "type": "u64"
          },
          {
            "name": "coordinators",
            "type": {
              "vec": "u64"
            }
          }
        ]
      }
    },
    {
      "name": "Seasons",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "seasons",
            "type": {
              "vec": {
                "defined": {
                  "name": "Season"
                }
              }
            }
          }
        ]
      }
    },
    {
      "name": "StakingAccount",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "authority_bump",
            "type": "u8"
          },
          {
            "name": "user_key",
            "type": "pubkey"
          },
          {
            "name": "coordinator_key",
            "type": "pubkey"
          },
          {
            "name": "voter_bump",
            "type": "u8"
          },
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "next_index",
            "type": "u8"
          }
        ]
      }
    },
    {
      "name": "StakingConfig",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "crnch_mint",
            "type": "pubkey"
          },
          {
            "name": "staking_admin_authority",
            "type": "pubkey"
          },
          {
            "name": "pool_authority",
            "type": "pubkey"
          },
          {
            "name": "crnch_governance_realm",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "StakingPosition",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "crnch_staked",
            "type": "u64"
          },
          {
            "name": "activation_epoch",
            "type": "u64"
          },
          {
            "name": "unlocking_start",
            "type": {
              "option": "u64"
            }
          },
          {
            "name": "shares_acquired",
            "type": "u64"
          },
          {
            "name": "target_with_parameters",
            "type": {
              "defined": {
                "name": "TargetWithParameters"
              }
            }
          }
        ]
      }
    },
    {
      "name": "StakingPositions",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "stake_account_key",
            "type": "pubkey"
          },
          {
            "name": "positions",
            "type": {
              "vec": {
                "defined": {
                  "name": "StakingPosition"
                }
              }
            }
          },
          {
            "name": "total_crnch_staked",
            "type": "u64"
          },
          {
            "name": "bump",
            "type": "u8"
          }
        ]
      }
    },
    {
      "name": "TargetWithParameters",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "CoordinatorPool",
            "fields": [
              {
                "name": "coordinator",
                "type": "pubkey"
              }
            ]
          },
          {
            "name": "Voting"
          }
        ]
      }
    }
  ]
}